export default __webpack_public_path__ + "static/media/webdesign_open.6f340cf0.png";